"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const UserAvatar_1 = __importDefault(require("../shared/UserAvatar"));
const setProfileImage_1 = __importDefault(require("../../actions/users/setProfileImage"));
const Alert_1 = require("../../components/modals/Alert");
const constants_1 = require("../../constants");
exports.default = react_1.default.memo(MyAvatar);
const useStyles = makeStyles_1.default((theme) => ({
    myAvatar: {
        cursor: "pointer"
    }
}));
function MyAvatar(props) {
    var _a, _b, _c;
    const dispatch = react_redux_1.useDispatch();
    const userImage = react_redux_1.useSelector((state) => {
        const me = state.usersState.me;
        return me ? {
            userId: me.userId,
            imageId: me.imageId,
            blobUrl: me.imageBlobUrl
        } : null;
    }, react_redux_1.shallowEqual);
    const userExists = userImage !== null;
    const classes = useStyles();
    function onAvatarFileSelected(event) {
        if (!userImage) {
            return;
        }
        let files = event.target.files;
        if (!files || !files[0]) {
            return;
        }
        const file = files[0];
        const reader = new FileReader();
        reader.onload = function (e) {
            const mimeType = file.type;
            const data = e.target.result;
            if (!mimeType.startsWith("image/")) {
                Alert_1.alertDialog({
                    title: "Invalid avatar image",
                    text: "You must choose an image"
                });
                return;
            }
            if (data.byteLength > constants_1.MAX_AVATAR_SIZE) {
                Alert_1.alertDialog({
                    title: "Invalid avatar image",
                    text: "Your image file must be less than 256 Kb in size"
                });
                return;
            }
            dispatch(setProfileImage_1.default(userImage.userId, new Uint8Array(data)));
        };
        reader.readAsArrayBuffer(file);
    }
    return (react_1.default.createElement("label", { className: classes.myAvatar },
        react_1.default.createElement(UserAvatar_1.default, { isUserOnline: true, userId: (_a = userImage === null || userImage === void 0 ? void 0 : userImage.userId) !== null && _a !== void 0 ? _a : null, imageId: (_b = userImage === null || userImage === void 0 ? void 0 : userImage.imageId) !== null && _b !== void 0 ? _b : null, blobUrl: (_c = userImage === null || userImage === void 0 ? void 0 : userImage.blobUrl) !== null && _c !== void 0 ? _c : null, size: props.size }),
        userExists ? react_1.default.createElement("input", { hidden: true, type: "file", accept: ".jpg, .jpeg, .png, .gif", onChange: onAvatarFileSelected }) : null));
}
